export const sortingValues = {
  custom: 'custom',
  random: 'random',
  alphabetical: 'alphabetical',
}

export const sortingOptions = [
  {
    label: 'Alfabético',
    value: sortingValues.alphabetical,
  },
  {
    label: 'Aleatorio',
    value: sortingValues.random,
  },
  {
    label: 'Personalizado: Usar orden definido manualmente en el listado',
    value: sortingValues.custom,
  },
]
